import React, { FC, useEffect, useState } from "react";
import { Button, Notification, toast } from "@telia/teddy";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import moment from "moment";
import { connect, useDispatch, useSelector } from "react-redux";
import { FORM_ID, CustomerType, CUSTOMER_TYPE, MAX_PRICE_FOR_NEW_NUMBER } from "../../../../../../constants";
import { MAX_AGE_UNG } from "../../../../../../constants/app";
import PAGES from "../../../../../../constants/pages";
import { Discount, ICartItemWithBundleId, RootState } from "../../../../../../models";
import { ChangeProductUserRequestBody } from "../../../../../../models/actionPayloads/addMember";
import LeaseLimitModal from "../../../../checkout/components/molecules/LeaseLimitModal/LeaseLimitModal";
import SmartDiscountModal from "../../../../checkout/components/molecules/SmartDiscountModal/SmartDiscountModal";
import WebdealModal from "../../../../checkout/components/molecules/WebdealModal/WebdealModal";
import {
    addWebdealAccessory,
    removeItemByIdFromCart,
    setActiveSubscription,
} from "../../../../checkout/state/actions/cartActions";
import {
    isSubscriptionDraft as isSubscriptionDraftSelector,
    getActiveSubscription,
    getItemByBundleId,
    hasItemsWithIsWebdeal,
} from "../../../../checkout/state/selectors/cartSelectors";
import * as COMBINED_SELECTORS from "../../../../checkout/state/selectors/combinedSelectors";
import { getPhoneNumberCheckType } from "../../../../checkout/state/selectors/phoneNumberSelectors";
import {
    isProductUserMandatory as isProductUserMandatorySelector,
    isChildSubscription as isChildSubscriptionSelector,
    isJuniorSubscription as isJuniorSubscriptionSelector,
    isUngSubscription as isUngSubscriptionSelector,
    isTeliaTryggSubscription as isTeliaTryggSubscriptionSelector,
    getSubscriptionMaxAgeAllowed,
    getSubscriptions,
} from "../../../../checkout/state/selectors/subscriptionsSelectors";
import { isValidSubscriptionAge } from "../../../../checkout/utils";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import * as NAVIGATION_SELECTORS from "../../../../navigation/state/selectors";
import { fetchWebdeals } from "../../../../webdeals/state/actions";
import * as WEBDEAL_SELECTORS from "../../../../webdeals/state/selectors";
import { post as Ajax_post } from "../../../../app/Ajax";
import { API_URL_RETAILER_CHANGE_PRODUCT_USER } from "../../../api";
import { setValue, resetCustomerInfo } from "../../../state/actions";
import { RETAILER_SET_CUSTOMER_DETAILS } from "../../../state/actionTypes";
import { isScopedChange } from "../../../utils";
import { setCustomerDetails } from "../../../state/actions/customerActions";
import {
    setReopenExistingSubscriptionPhone,
    clearExistingSubscriptionForChange,
    nextSubscriptionStep,
    setExistingSubscriptionForChange,
} from "../../../state/actions/subscriptionStepsActions";
import * as CUSTOMER_INFO_SELECTORS from "../../../state/selectors/customerInfoSelectors";
import { getFormById } from "../../../state/selectors/formSelectors";
import CustomerInfoForm from "../../molecules/CustomerInfoForm/CustomerInfoForm";
import TryggUserSelect from "../../molecules/TryggUserSelect/TryggUserSelect";
import ExistingSubscriptionDiscardModal from "../../molecules/ExistingSubscriptionDiscardModal/ExistingSubscriptionDiscardModal";
import "./SubscriptionUserInfo.less";
import SubscriptionStepsControls from "../../molecules/SubscriptionStepsControls/SubscriptionStepsControls";
import {
    getExistingSubscriptionForChange,
    getCustomerLegalOwnerIndividual,
} from "../../../state/selectors/customerSelectors";

interface StateProps {
    campaignId: string;
    currentBundleItem: ICartItemWithBundleId;
    customerType?: CustomerType;
    hasWebdealsInCart: boolean;
    isProductUserMandatory: boolean;
    isJuniorOrBarnSubscription: boolean;
    isTeliaTryggSubscription: boolean;
    isPuDifferentFromLo: boolean;
    isFetchingData: boolean;
    isNavigating: boolean;
    isOptingOutForTeliaXServices: boolean;
    isProductUserAgeOk: boolean;
    isSmartDiscountPriceLowerThanNormalPrice: boolean;
    isSubscriptionDraft: boolean;
    selectedSubscriptionId: string | undefined;
    skuByBundleId: string | null;
    webdeals: Discount[];
}

const SubscriptionUserInfo: FC<StateProps> = ({
    campaignId,
    currentBundleItem,
    isFetchingData,
    isNavigating,
    isSubscriptionDraft,
    selectedSubscriptionId,
    isOptingOutForTeliaXServices,
    customerType,
    isSmartDiscountPriceLowerThanNormalPrice,
    isProductUserMandatory,
    isJuniorOrBarnSubscription,
    isTeliaTryggSubscription,
    isPuDifferentFromLo,
    isProductUserAgeOk,
    skuByBundleId,
    hasWebdealsInCart,
    webdeals,
}) => {
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [showWebdealModal, setShowWebdealModal] = useState(false);
    const [showLeaseLimitModal, setShowLeaseLimitModal] = useState(false);
    const [leaseLimitMaxAmount, setLeaseLimitMaxAmount] = useState(MAX_PRICE_FOR_NEW_NUMBER);
    const [showSmartDiscountModal, setShowSmartDiscountModal] = useState(false);
    const [discardModalSubscriptionId, setDiscardModalSubscriptionId] = useState<string | null>(null);
    const existingSubscriptionForChange = useSelector(getExistingSubscriptionForChange);
    const isProductUserScopeChange = existingSubscriptionForChange?.changeScope === "productUser";
    const subscriptions = useSelector(getSubscriptions);
    const form = useSelector((state: RootState) => getFormById(state, FORM_ID.CUSTOMER_PRODUCT_USER));
    const isProductUserDifferentThanLegalOwner = useSelector(
        CUSTOMER_INFO_SELECTORS.isProductUserDifferentThanLegalOwner,
    );
    const legalOwner = useSelector(getCustomerLegalOwnerIndividual);

    const closeExistingInlineEdit = () => {
        if (isSubscriptionDraft && selectedSubscriptionId) {
            setDiscardModalSubscriptionId(selectedSubscriptionId);
            return;
        }

        if (existingSubscriptionForChange?.phoneNumber) {
            dispatch(setReopenExistingSubscriptionPhone(existingSubscriptionForChange.phoneNumber));
        }
        dispatch(setActiveSubscription());
        if (existingSubscriptionForChange) {
            dispatch(clearExistingSubscriptionForChange());
            dispatch(setExistingSubscriptionForChange(undefined));
        }
    };

    const confirmDiscardExistingInlineEdit = () => {
        if (!discardModalSubscriptionId) {
            return;
        }

        if (existingSubscriptionForChange?.phoneNumber) {
            dispatch(setReopenExistingSubscriptionPhone(existingSubscriptionForChange.phoneNumber));
        }
        dispatch(removeItemByIdFromCart(discardModalSubscriptionId, false));
        dispatch(setActiveSubscription());
        setDiscardModalSubscriptionId(null);
        if (existingSubscriptionForChange) {
            dispatch(clearExistingSubscriptionForChange());
            dispatch(setExistingSubscriptionForChange(undefined));
        }
    };

    useEffect(() => {
        if (isProductUserMandatory || isJuniorOrBarnSubscription || isPuDifferentFromLo) {
            dispatch(setValue("isProductUserDifferentThanLegalOwner", true));
        }
    }, [isProductUserMandatory, isJuniorOrBarnSubscription, isPuDifferentFromLo, selectedSubscriptionId, dispatch]);

    const updateMemberDetails = async () => {
        if (!selectedSubscriptionId) return false;

        try {
            const response = await dispatch(
                setCustomerDetails({
                    customerId: selectedSubscriptionId,
                    campaignId,
                    isOptingOutForTeliaXServices,
                }),
            );

            const hasMinUpfrontPrice = typeof response.minUpfrontPrice === "number" && response.minUpfrontPrice > 0;
            if (response.isNewNumberWithPotentialFraud || hasMinUpfrontPrice) {
                const totalPrice = Number(currentBundleItem?.price?.total ?? 0);
                setLeaseLimitMaxAmount(
                    hasMinUpfrontPrice ? Math.max(0, totalPrice - response.minUpfrontPrice!) : MAX_PRICE_FOR_NEW_NUMBER,
                );
                setShowLeaseLimitModal(true);
            }

            return response.hasUpdatedCustomer;
        } catch (err: unknown) {
            if (err && typeof err === "object" && "displayableMessage" in err) {
                setErrorMessage(err.displayableMessage as string);
            } else {
                setErrorMessage(err instanceof Error ? err.message : "Det oppsto en ukjent feil");
            }
        }
    };

    const discountCustomerType = customerType === CUSTOMER_TYPE.PORT_IN ? CUSTOMER_TYPE.NEW : customerType;

    const shouldShowWebdealModal = (deals: Discount[]): boolean => {
        if (
            deals.length > 1 ||
            deals[0]?.additionalProducts.productNumbers.length > 1 ||
            deals[0]?.additionalProducts.variants[0].discountedPrice > 0
        ) {
            return true;
        }
        return false;
    };

    const handleOnContinue = async (error?: { error: string }) => {
        if (error) {
            // Do nothing but show error on page
            setShowWebdealModal(false);
            return;
        }
        toast.success(`Abonnementet er oppdatert`, {
            position: "top-center",
        });
        dispatch(resetCustomerInfo());
        if (selectedSubscriptionId) {
            dispatch(nextSubscriptionStep(selectedSubscriptionId));
        }
        if (existingSubscriptionForChange?.phoneNumber) {
            dispatch(setReopenExistingSubscriptionPhone(existingSubscriptionForChange.phoneNumber));
        }
        dispatch(setActiveSubscription());
        if (existingSubscriptionForChange) {
            dispatch(clearExistingSubscriptionForChange());
            dispatch(setExistingSubscriptionForChange(undefined));
        }
    };

    const onSubmitMemberDetails = async () => {
        const discountSubscriptionType = currentBundleItem?.discount?.discountSubscriptionType || [];
        const upCaseDiscountCustomerType = discountCustomerType ? discountCustomerType.toUpperCase() : "";
        const isSmartDiscount = currentBundleItem?.discount?.isSmartDiscount;
        if (
            !showSmartDiscountModal &&
            isSmartDiscount &&
            isSmartDiscountPriceLowerThanNormalPrice &&
            !discountSubscriptionType.includes(upCaseDiscountCustomerType)
        ) {
            setShowSmartDiscountModal(true);
            return;
        }

        const hasUpdatedCustomer = await updateMemberDetails();

        if (hasUpdatedCustomer) {
            if (!selectedSubscriptionId) return;

            // No SKU for current bundleId? Just continue on.
            if (!skuByBundleId) {
                return handleOnContinue();
            }

            let deals: Discount[] = [];
            if (hasWebdealsInCart) {
                const webdealData = await dispatch(fetchWebdeals(skuByBundleId));
                deals = _get(webdealData, "action.payload.webdeals", []);
            }

            if (shouldShowWebdealModal(deals)) {
                setShowWebdealModal(true);
            } else if (deals.length === 1 && deals[0].additionalProducts.variants.length >= 1) {
                await dispatch(
                    addWebdealAccessory(
                        [deals[0].additionalProducts.variants[0].sku],
                        undefined,
                        false,
                        selectedSubscriptionId,
                    ),
                );
                handleOnContinue();
            } else {
                handleOnContinue();
            }
        }
    };

    const getDuplicateUngBarnFirstName = (): string | null => {
        if (!selectedSubscriptionId) return null;

        const currentCode = subscriptions[selectedSubscriptionId]?.code || "";
        const isCurrentBarnOrUng =
            currentCode.includes("BARN") || currentCode.includes("JUNIOR") || currentCode.includes("_UNG");
        if (!isCurrentBarnOrUng) return null;
        const currentFirstName = isProductUserDifferentThanLegalOwner
            ? (form.values?.user?.[VALIDATION_FIELD.FIRST_NAME] || "").trim().toLowerCase()
            : (legalOwner?.firstName || "").trim().toLowerCase();
        const currentLastName = isProductUserDifferentThanLegalOwner
            ? (form.values?.user?.[VALIDATION_FIELD.LAST_NAME] || "").trim().toLowerCase()
            : (legalOwner?.lastName || "").trim().toLowerCase();
        const currentBirthDate = isProductUserDifferentThanLegalOwner
            ? (form.values?.user?.[VALIDATION_FIELD.BIRTHDATE] || "").trim()
            : (legalOwner?.birthDate || "").trim();

        if (!currentFirstName || !currentLastName || !currentBirthDate) return null;

        for (const [id, sub] of Object.entries(subscriptions)) {
            if (id === selectedSubscriptionId) continue;
            const code = sub.code || "";
            const isBarnOrUng = code.includes("BARN") || code.includes("JUNIOR") || code.includes("_UNG");
            if (!isBarnOrUng || !sub.productUser) continue;

            const puFirstName = (sub.productUser.firstName || "").trim().toLowerCase();
            const puLastName = (sub.productUser.lastName || "").trim().toLowerCase();
            const puBirthDate = (sub.productUser.birthDate || "").trim();

            const birthMatch =
                puBirthDate === currentBirthDate ||
                moment(puBirthDate, ["DD.MM.YYYY", "YYYY-MM-DD"], true).isSame(
                    moment(currentBirthDate, ["DD.MM.YYYY", "YYYY-MM-DD"], true),
                    "day",
                );

            if (puFirstName === currentFirstName && puLastName === currentLastName && birthMatch) {
                return sub.productUser.firstName;
            }
        }
        return null;
    };

    const handleOnSubmit = async () => {
        try {
            setErrorMessage(null);

            const duplicateName = getDuplicateUngBarnFirstName();
            if (duplicateName) {
                setErrorMessage(
                    `Det er kun tillatt med ett barn/ung abonnement per bruker. ${duplicateName} har allerede et abonnement i handlekurven`,
                );
                return;
            }

            if (existingSubscriptionForChange) {
                await submitProductUserChange();
                return;
            }

            if (isSubscriptionDraft) {
                onSubmitMemberDetails();
            } else {
                const hasUpdatedCustomer = await updateMemberDetails();
                if (hasUpdatedCustomer && selectedSubscriptionId) {
                    toast.success(`Abonnementet er oppdatert`, {
                        position: "top-center",
                    });
                    dispatch(resetCustomerInfo());
                    dispatch(nextSubscriptionStep(selectedSubscriptionId));
                    dispatch(setActiveSubscription());
                }
            }
        } catch (e: any) {
            setErrorMessage(e?.displayable ? e.error : "Det oppsto en feil under innsending av brukerinformasjon.");
        }
    };

    const submitProductUserChange = async () => {
        if (!selectedSubscriptionId) return;

        const values = form.values?.user;
        const useProductUser = isProductUserDifferentThanLegalOwner;

        const body: ChangeProductUserRequestBody = {
            subscriptionCartItemId: selectedSubscriptionId,
            firstName: useProductUser ? values?.[VALIDATION_FIELD.FIRST_NAME] : legalOwner?.firstName || "",
            lastName: useProductUser ? values?.[VALIDATION_FIELD.LAST_NAME] : legalOwner?.lastName || "",
            birthDate: useProductUser ? values?.[VALIDATION_FIELD.BIRTHDATE] : legalOwner?.birthDate || "",
            email: values?.[VALIDATION_FIELD.PRODUCT_USER_EMAIL] || "",
            postcode: useProductUser ? values?.[VALIDATION_FIELD.POSTCODE] : undefined,
        };

        const responsePromise = Ajax_post<{
            cart: { content?: unknown[] };
            isZipNeeded?: boolean;
            isNotFound?: boolean;
        }>({ url: API_URL_RETAILER_CHANGE_PRODUCT_USER, data: body }, dispatch);

        dispatch({ type: RETAILER_SET_CUSTOMER_DETAILS, payload: responsePromise });

        const response = await responsePromise;

        if (response.isZipNeeded || response.isNotFound) {
            dispatch(setValue("isZipNeeded", !!response.isZipNeeded));
            dispatch(setValue("isNotFound", !!response.isNotFound));
            return;
        }

        toast.success("Bruker er endret", { position: "top-center" });
        dispatch(resetCustomerInfo());
        if (existingSubscriptionForChange?.phoneNumber) {
            dispatch(setReopenExistingSubscriptionPhone(existingSubscriptionForChange.phoneNumber));
        }
        dispatch(setActiveSubscription());
        if (existingSubscriptionForChange) {
            dispatch(clearExistingSubscriptionForChange());
            dispatch(setExistingSubscriptionForChange(undefined));
        }
    };

    return (
        <div className="subscription-user-info" data-cy="expanded-member-card">
            <ExistingSubscriptionDiscardModal
                open={!!discardModalSubscriptionId}
                onClose={() => setDiscardModalSubscriptionId(null)}
                onConfirm={confirmDiscardExistingInlineEdit}
            />
            {showLeaseLimitModal && currentBundleItem.leaseMonths && (
                <LeaseLimitModal
                    cartItem={currentBundleItem}
                    open={showLeaseLimitModal}
                    maxAllowedLeaseAmount={leaseLimitMaxAmount}
                    close={async (shouldResubmit) => {
                        setShowLeaseLimitModal(false);
                        if (shouldResubmit) {
                            await onSubmitMemberDetails();
                        }
                    }}
                    urlForTracking={PAGES.RETAILER.ORDER.SUBSCRIPTION.URL}
                />
            )}
            {showWebdealModal && selectedSubscriptionId && (
                <WebdealModal
                    onContinue={(error) => handleOnContinue(error)}
                    cartItemId={selectedSubscriptionId}
                    webdeals={webdeals}
                />
            )}
            {showSmartDiscountModal && (
                <SmartDiscountModal
                    handleOnContinue={() => onSubmitMemberDetails()}
                    onClose={() => setShowSmartDiscountModal(false)}
                    discountCustomerType={discountCustomerType}
                    currentBundleItem={currentBundleItem}
                />
            )}

            {isTeliaTryggSubscription ? (
                <TryggUserSelect onSubmitCustomerDetails={handleOnSubmit} />
            ) : (
                <CustomerInfoForm onSubmitCustomerDetails={handleOnSubmit} />
            )}
            {errorMessage && (
                <div className="subscription-user-info__error">
                    <Notification type="tile" variant="error" mb="300">
                        <Notification.Icon />
                        <Notification.Text>{errorMessage}</Notification.Text>
                    </Notification>
                </div>
            )}
            <SubscriptionStepsControls
                hideBack={isScopedChange(existingSubscriptionForChange?.changeScope)}
                nextLabel={isProductUserScopeChange ? "Fullfør" : undefined}
                onSecondaryClick={isProductUserScopeChange ? closeExistingInlineEdit : undefined}
                nextButton={
                    <Button
                        className="subscription-user-info__step-button"
                        disabled={isFetchingData || isNavigating || !isProductUserAgeOk}
                        type="submit"
                        loading={isFetchingData}
                        form={FORM_ID.CUSTOMER_PRODUCT_USER}
                        autoFocus
                    >
                        <span>{isProductUserScopeChange ? "Fullfør" : "Fullfør abonnement"}</span>
                    </Button>
                }
            />
        </div>
    );
};

const mapStateToProps: (state: RootState) => StateProps = (state) => {
    const selectedSubscriptionId = getActiveSubscription(state);
    const existingSubscriptionForChange = getExistingSubscriptionForChange(state);
    return {
        isFetchingData: LOADING_SELECTORS.isLoading(state),
        isNavigating: NAVIGATION_SELECTORS.isNavigating(state),
        campaignId: COMBINED_SELECTORS.getCampaignId(),
        selectedSubscriptionId: getActiveSubscription(state),
        isSubscriptionDraft: selectedSubscriptionId
            ? isSubscriptionDraftSelector(state, selectedSubscriptionId)
            : false,
        currentBundleItem: getItemByBundleId(state, selectedSubscriptionId)[0],
        isOptingOutForTeliaXServices: CUSTOMER_INFO_SELECTORS.isOptingOutForTeliaXServices(state),
        customerType: getPhoneNumberCheckType(state, selectedSubscriptionId),
        isSmartDiscountPriceLowerThanNormalPrice: COMBINED_SELECTORS.isSmartDiscountPriceLowerThanNormalPrice(state),
        skuByBundleId: selectedSubscriptionId
            ? COMBINED_SELECTORS.getSkuByBundleId(state, selectedSubscriptionId)
            : null,
        hasWebdealsInCart: hasItemsWithIsWebdeal(state),
        isTeliaTryggSubscription: selectedSubscriptionId
            ? isTeliaTryggSubscriptionSelector(state, selectedSubscriptionId)
            : false,
        isProductUserMandatory:
            isProductUserMandatorySelector(state, selectedSubscriptionId) || !!existingSubscriptionForChange,
        isJuniorOrBarnSubscription: (() => {
            if (!selectedSubscriptionId) return false;
            if (
                isChildSubscriptionSelector(state, selectedSubscriptionId) ||
                isJuniorSubscriptionSelector(state, selectedSubscriptionId)
            ) {
                return true;
            }
            if (isUngSubscriptionSelector(state, selectedSubscriptionId)) {
                const loBirthDate = getCustomerLegalOwnerIndividual(state)?.birthDate;
                if (!loBirthDate) return false;
                const loAge = moment().diff(moment(loBirthDate, ["DD.MM.YYYY", "YYYY-MM-DD"], true), "years", false);
                return loAge >= MAX_AGE_UNG;
            }
            return false;
        })(),
        isPuDifferentFromLo: (() => {
            const existing = getExistingSubscriptionForChange(state);
            const lo = getCustomerLegalOwnerIndividual(state);
            if (!existing?.firstName || !lo?.firstName) return false;
            return (
                existing.firstName.toLowerCase() !== lo.firstName.toLowerCase() ||
                (existing.lastName || "").toLowerCase() !== (lo.lastName || "").toLowerCase()
            );
        })(),
        isProductUserAgeOk: (() => {
            // Check age based on the birthdate entered in the form
            const form = getFormById(state, FORM_ID.CUSTOMER_PRODUCT_USER);
            const isProductUserDifferentThanLegalOwner =
                CUSTOMER_INFO_SELECTORS.isProductUserDifferentThanLegalOwner(state);
            const rawBirthDate = isProductUserDifferentThanLegalOwner
                ? _get(form, `values.user.${VALIDATION_FIELD.BIRTHDATE}`, undefined)
                : CUSTOMER_INFO_SELECTORS.getLegalOwnerBirthdate(state);
            const birthDate = _isEmpty(rawBirthDate) ? undefined : rawBirthDate;
            const subscriptionMaxAgeAllowed = getSubscriptionMaxAgeAllowed(state, selectedSubscriptionId);

            // If this is an existing subscription change and we have an age restriction
            const existing = getExistingSubscriptionForChange(state);
            if (existing && subscriptionMaxAgeAllowed && existing.birthDate) {
                // Check if existing product user is too old
                const existingBirthMoment = moment(existing.birthDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
                if (existingBirthMoment.isValid()) {
                    const existingAge = moment().diff(existingBirthMoment, "years", false);
                    if (existingAge >= subscriptionMaxAgeAllowed) {
                        // Existing user is too old - require a valid new birthdate
                        if (!birthDate) {
                            return false; // No birthdate entered yet
                        }
                        // Check if the new birthdate is valid and within age limit
                        const newBirthMoment = moment(birthDate, ["DD.MM.YYYY", "YYYY-MM-DD"], true);
                        if (!newBirthMoment.isValid()) {
                            return false; // Invalid format
                        }
                        const newAge = moment().diff(newBirthMoment, "years", false);
                        return newAge < subscriptionMaxAgeAllowed;
                    }
                }
            }

            // Default validation
            return isValidSubscriptionAge({
                subscriptionMaxAgeAllowed,
                productUserBirthDate: birthDate,
                useProductUserAge: true,
            });
        })(),
        webdeals: WEBDEAL_SELECTORS.getWebdealsState(state),
    };
};

export default connect(mapStateToProps)(SubscriptionUserInfo);
